import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white mt-20" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img
              src="/logo-white.png"
              alt="Wine Collection & Spirits"
              className="h-24 w-auto object-contain mb-4"
              data-testid="footer-logo"
            />
            <p className="text-gray-400 text-sm">
              Premium wine and spirits import and distribution in Miami, Florida.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white">Home</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white">Services</Link></li>
              <li><Link to="/products" className="text-gray-400 hover:text-white">Products</Link></li>
              <li><Link to="/management" className="text-gray-400 hover:text-white">Management</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">For Businesses</h3>
            <ul className="space-y-2">
              <li><Link to="/brand-registration" className="text-gray-400 hover:text-white">Brand Registration</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white">Brand Partnership</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white">Get In Touch</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start space-x-2">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span>7227 NW 32 street Miami FL 33122</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={18} />
                <span>+1 (786) 359-6478</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={18} />
                <span>Paul@winecollectionspirits.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Wine Collection & Spirits. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;